import React, { useEffect, useState } from "react"
import { ActivityIndicator, ScrollView, StatusBar, Text, View } from "react-native"
import styles from "../../Consent/styles"
import { Button } from "@Components/CustomButton/Button"
import { BreeSerifText } from "@Components/CustomText/BreeSerifText"
import { OpenSansText } from "@Components/CustomText/OpenSansText"
import { baseColors, baseFontFamily } from "@Constants/baseStyles"
import { Switch } from "react-native-paper"
import { useRecoilValue } from "recoil"
import { userAtom } from "@Recoil/Atom/userAtom"
import { useConsentHooks } from "../../../Hooks/useConsentHooks"
import { useNavigation } from "@react-navigation/native"
import { LocalStorage } from "@Services/sharedPreferences/localStorage"

export const SwitchContent = ({ disabled, color, status, onPress }) =>
    <Switch
        disabled={disabled}
        color={color}
        onValueChange={onPress}
        value={status}
    />

const NoticeConsent = ({ isFirstCheck }) => {
    const navigation = useNavigation()
    const user = useRecoilValue(userAtom)
    const [condition, setCondition] = useState(false)
    const [appServices, setAppServices] = useState(null)
    const [statistics, setStatistics] = useState(null)
    const [communication, setCommunication] = useState(null)
    const [evalProgress, setEvalProgress] = useState(false)
    const [doStatistics, setDoStatistics] = useState(false)
    const [focusTrace, setFocusTrace] = useState(false)
    const [acceptContact, setAcceptContact] = useState(false)
    const [saveConsent, setSaveConsent] = useState(false)

    // Mettre à jour `canSubmit` pour vérifier que TOUS les switchs sont activés
    const canSubmit = () => (
        condition === true &&
        evalProgress === true &&
        doStatistics === true &&
        focusTrace === true &&
        acceptContact === true &&
        saveConsent === true
    );

    function RedirectionHandler(hasConsent) {
        if (hasConsent) {
            navigation.navigate("DiagnosticEducatifList")
        }
    }

    const {
        handleFetchConsent,
        patientConsent,
        fetchingPatientConsent: fetching,

        performSaveNoticeConsent,
        saving,
        updateData
    } = useConsentHooks()

    useEffect(() => {
        handleFetchConsent()
    }, [user, updateData])

    useEffect(() => {
        if (patientConsent) {
            setCondition(patientConsent?.condition || false)
            setAppServices(patientConsent?.appServices || false)
            setStatistics(patientConsent?.statistics || false)
            setCommunication(patientConsent?.communication || false)
            setEvalProgress(patientConsent?.evalProgress || false)
            setDoStatistics(patientConsent?.doStatistics || false)
            setFocusTrace(patientConsent?.focusTrace || false)
            setAcceptContact(patientConsent?.acceptContact || false)
            setSaveConsent(patientConsent?.saveConsent || false)
        }
    }, [patientConsent])

    const payload = {
        cgu: condition,
        major: true,
        services: appServices ?? false,
        statistics: statistics ?? false,
        communication: communication ?? false,
        evalProgress: evalProgress ?? false,
        doStatistics: doStatistics ?? false,
        focusTrace: focusTrace ?? false,
        acceptContact: acceptContact ?? false,
        saveConsent: saveConsent ?? false
    }

    LocalStorage.getConsentStatus()
        .then((currentNoticeConstentStatus) => {
            const hasConsent = Boolean(currentNoticeConstentStatus?.participateInStudy)
            console.log({ currentNoticeConstentStatus, hasConsent })
            RedirectionHandler(hasConsent)
        })
        .catch(() => {
            console.log({ errorGetingNoticeStatusConstent: "errorGetingNoticeStatusConstent" })
        })

    return (
        <View style={[styles.container, { paddingTop: isFirstCheck ? StatusBar.currentHeight : undefined }]}>
            <ScrollView
                keyboardShouldPersistTaps={"handled"}
                showsVerticalScrollIndicator={false}
                contentContainerStyle={{ paddingBottom: 100 }}
            >
                <View style={styles.content}>
                    {fetching ? (
                        <View style={{ flex: 1, justifyContent: "center", alignContent: "center" }}>
                            <ActivityIndicator color={baseColors.green.primary} size="large" style={{ padding: 20 }} />
                            <OpenSansText
                                defaultFontFamily={baseFontFamily.OpenSansRegular}
                                style={{ textAlign: "center" }}
                                fontSize={16}
                            >
                                Chargement des données en cours...
                            </OpenSansText>
                        </View>
                    ) : (
                        <>
                            <View style={styles.header}>
                                <BreeSerifText style={styles.title}>Formulaire de consentement au Recueil de données personnelles dans le cadre du PROGRAMME SALUTANCE 5.0</BreeSerifText>
                                <OpenSansText defaultFontFamily={baseFontFamily.OpenSansRegular} fontSize={14}>
                                    L'association des "Atelier du Devenir" dont le siège est situé à 3 allée Roland Garros 31520 Ramonville Saint-Agne est le promoteur du programme de prévention "SALUTANCE 5.0", dans ce cadre l'association est amenée à traiter les données collectées vous concernant lors de votre participation au programme et agit comme responsable de traitement.
                                </OpenSansText>
                            </View>

                            {/*<OpenSansText
                                defaultFontFamily={baseFontFamily.OpenSansSemiBold}
                                fontSize={14}
                                style={{ marginBottom: 18 }}
                            >
                                Cochez les cases suivants pour pouvoir utiliser l'application IVEHTE.
                            </OpenSansText>*/}

                            <View style={styles.firstCheckBoxContent}>
                                <SwitchContent
                                    status={condition}
                                    onPress={setCondition}
                                    color={baseColors.orange.primary}
                                    disabled={fetching}
                                />

                                <OpenSansText
                                    defaultFontFamily={baseFontFamily.OpenSansSemiBold}
                                    fontSize={14}
                                    style={styles.checkBoxLabel}
                                >
                                    Je reconnais avoir lu et compris la notice d'information relative à la protection des données personnelles qui m'a été remise.
                                </OpenSansText>
                            </View>

                            <OpenSansText
                                defaultFontFamily={baseFontFamily.OpenSansSemiBold}
                                fontSize={14}
                                style={{ marginBottom: 18 }}
                            >
                                J'accepte que mes données personnelles soient enregistrées et traitées par le responsable de traitement et ses sous-traitants, conformément au Règlement Général de Protection des Données de 2018 sur la protection des données personnelles et notre politique de protection des données pour les finalités suivantes :
                            </OpenSansText>

                            <View style={styles.thirstCheckBoxContent}>
                                <SwitchContent
                                    status={saveConsent}
                                    onPress={setSaveConsent}
                                    color={baseColors.orange.primary}
                                    disabled={fetching}
                                />
                                <OpenSansText
                                    defaultFontFamily={baseFontFamily.OpenSansSemiBold}
                                    fontSize={14}
                                    style={styles.checkBoxLabel}
                                >
                                    Recueillir et conserver la preuve de votre consentement
                                </OpenSansText>
                            </View>

                            <View style={styles.thirstCheckBoxContent}>
                                <SwitchContent
                                    status={focusTrace}
                                    onPress={setFocusTrace}
                                    color={baseColors.green.primary}
                                    disabled={fetching}
                                />
                                <OpenSansText
                                    defaultFontFamily={baseFontFamily.OpenSansSemiBold}
                                    fontSize={14}
                                    style={styles.checkBoxLabelGreen}
                                >
                                    Retracer votre présence au focus, si vous y avez participé
                                </OpenSansText>
                            </View>

                            <View style={styles.thirstCheckBoxContent}>
                                <SwitchContent
                                    status={acceptContact}
                                    onPress={setAcceptContact}
                                    color={baseColors.orange.primary}
                                    disabled={fetching}
                                />
                                <OpenSansText
                                    defaultFontFamily={baseFontFamily.OpenSansSemiBold}
                                    fontSize={14}
                                    style={styles.checkBoxLabel}
                                >
                                    Permettre de vous contacter afin de vous transmettre les informations relatives au programme
                                </OpenSansText>
                            </View>

                            <View style={styles.thirstCheckBoxContent}>
                                <SwitchContent
                                    status={evalProgress}
                                    onPress={setEvalProgress}
                                    color={baseColors.green.primary}
                                    disabled={fetching}
                                />
                                <OpenSansText
                                    defaultFontFamily={baseFontFamily.OpenSansSemiBold}
                                    fontSize={14}
                                    style={styles.checkBoxLabelGreen}
                                >
                                    D'évaluer vos progrès en termes d'activité physique, d'alimentation et de motivation
                                </OpenSansText>
                            </View>

                            <View style={styles.thirstCheckBoxContent}>
                                <SwitchContent
                                    status={doStatistics}
                                    onPress={setDoStatistics}
                                    color={baseColors.orange.primary}
                                    disabled={fetching}
                                />
                                <OpenSansText
                                    defaultFontFamily={baseFontFamily.OpenSansSemiBold}
                                    fontSize={14}
                                    style={styles.checkBoxLabel}
                                >
                                    Effectuer des statistiques, de la recherche et du développement dans le domaine de la prévention de la santé avec un objectif de publication.
                                </OpenSansText>
                            </View>

                            <OpenSansText
                                defaultFontFamily={baseFontFamily.OpenSansSemiBold}
                                fontSize={14}
                                style={{ marginBottom: 18 }}
                            >
                                Vous n'êtes pas obligé de nous accorder ce consentement, mais si vous décidez de le refuser, votre participation au programme ne sera pas possible.
                            </OpenSansText>

                            <OpenSansText
                                defaultFontFamily={baseFontFamily.OpenSansSemiBold}
                                fontSize={14}
                                style={{ marginBottom: 18 }}
                            >
                                Vous disposez également d'un droit de retrait de votre consentement, d'un droit d'opposition, d'un droit à la limitation du traitement de vos données et d'un droit de retrait de votre consentement (cf. <a href="https://www.cnil.fr" target="_blank">cnil.fr</a> pour plus d'information sur vos droits). Pour exercer ces droits ou pour toute question sur le traitement de vos données dans ce dispositif, vous pouvez contacter la cheffe de projet du programme SALUTANCE 5.0 par mail salutance5.0@gmail.com
                            </OpenSansText>
                        </>
                    )}
                </View>
            </ScrollView>

            <Button
                marginTop={5}
                loading={saving}
                onPress={() => performSaveNoticeConsent({ payload })}
                text="valider"
                width="60%"
                disabled={saving || fetching || !canSubmit()}
                backgroundColor={baseColors.green.primary}
                labelColor={"white"}
            />
        </View>
    )
}

export default NoticeConsent
